import { createGlobalStyle } from '@moonpig/launchpad-utils'

export const OverrideReachModalPadding = createGlobalStyle`
  [role="dialog"] > :first-child {
    padding: 0 !important;
  }
`
